import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentLexiClient, ImagesNumeraLexiClient, ImagesObjectDetailsDto } from '@lexi-clients/lexi';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DxTreeListComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: "app-bon-detail-photos",
    templateUrl: "./bon-detail-photos.component.html",
    styleUrls: ["./bon-detail-photos.component.scss"],
    standalone: false
})
export class BonDetailPhotosComponent implements OnInit, OnChanges {
  @ViewChild(DxTreeListComponent, { static: false }) treeList: DxTreeListComponent;

  dataSource: ImagesObjectDetailsDto[] = [];
  isPhotoPopupVisible: boolean = false;
  photosAAfficher = new Map<string, Map<string, SafeResourceUrl>>();
  currentPhotos: SafeResourceUrl[];

  @Input() bonId: number;
  @Input() isDisabled: boolean;
  @Input() refreshTab: boolean;

  @Output() nombrePhotos = new EventEmitter<number>();

  constructor(
    private imagesNumeraService: ImagesNumeraLexiClient,
    private documentService: DocumentLexiClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes) {
    if (changes.refreshTab) {
      this.getData();
    }
  }

  private getData() {
    this.imagesNumeraService
      .getForReceptionDetails(this.bonId)
      .subscribe((r) => {
        this.dataSource = r ?? [];
        if (this.dataSource.length) {
          // nbPhotos = distinct photosIds
          const nbPhotos = new Set<string>(this.dataSource.flatMap(l => l.photosIds).filter(id => !!id)).size;
          this.nombrePhotos.emit(nbPhotos);
        }
      });
  }

  displayPhotos(data: ImagesObjectDetailsDto) {
    this.getPhotos(data.photosIds, data.objetId); 
    this.isPhotoPopupVisible = !this.isPhotoPopupVisible;
  }

  async getPhotos(photoIdList, objetId) {
    if (!this.photosAAfficher.has(objetId)) {
      this.photosAAfficher.set(objetId, new Map<string, SafeResourceUrl>());
    };
    this.currentPhotos = [];
    photoIdList.forEach(async photoId => {
      if (!this.photosAAfficher.get(objetId).has(photoId)) {
        this.documentService.getContentById(photoId).subscribe(res => {
          let imageSource: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`);
          this.currentPhotos.push(imageSource);
          this.photosAAfficher.get(objetId).set(photoId, imageSource);
        });
      } else {
        this.currentPhotos.push(this.photosAAfficher.get(objetId).get(photoId));
      }
    });
  }

  clearDatagridFilters() {
    this.treeList.instance.clearFilter();
  }
  
  onStateResetClick() {
    let result = confirm("Toute personnalisation d'affichage sur cette page sera perdue, voulez-vous procéder ?", "Confirmation");
    result.then((dialogResult) => {
      this.treeList.instance.state(null);
    });
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'refresh',
        hint: 'Rafraîchir',
        onClick: this.getData.bind(this)
      }
    },
    {
      location: 'after',
      widget: 'dxButton',
      options: {
        hint: 'Réinitialiser les filtres',
        icon: 'deletetable',
        onClick: this.clearDatagridFilters.bind(this)
      }
    },
    {
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'clearformat',
        hint: 'Réinitialiser les personnalisations d\'affichage de la grille',
        onClick: this.onStateResetClick.bind(this)
      }
    }
    );
  }
}